"use client";

import { useState } from 'react';
import { useEffect } from "react";
import Header from "./header"; // Import your server component
import * as All from '@/element/common/elmntbase';

export default function SidemenuContentWrapper({children}:any) {
    const [open, setOpen] =  useState (false);

    useEffect(() => {
        const updateMenuState = () => {
            const ismenuOpen = localStorage.getItem("ismenuOpen") === 'true';
            setOpen(ismenuOpen);
        };

        // Initial load
        updateMenuState();

        // Listen to custom event
        window.addEventListener("sidemenuToggle", updateMenuState);

        return () => {
            window.removeEventListener("sidemenuToggle", updateMenuState);
        };
    }, []);    
    
    return (
            <>            
                <All.MotionDiv  className="menu-info justify-content-lg-center align-items-lg-center text-lg-center mt-5 mt-lg-0"
                    initial={{ opacity: 1, scale: 1, visibility: "visible" }}
                    animate={open 
                        ? {opacity: 1, scale: 1, visibility: "visible",
                            transition:{delay: 1.5, duration: 0.5, ease: "easeOut" }}  
                        :{ opacity: 0, scale: 1, visibility: "visible", 
                            transition:{delay:  0.2, duration: 0.5, ease: "easeOut" }  }
                    }> 
                            {children}
                </All.MotionDiv>         
            </>
    );
}